module.exports = __webpack_public_path__ + "static/media/ecommerce.8eb4e4e8.png";